import PortalMenu from './PortalMenu';

export default PortalMenu;
